import { render, staticRenderFns } from "./BuyProductXGiftY.vue?vue&type=template&id=c74a40ba&scoped=true&"
import script from "./BuyProductXGiftY.vue?vue&type=script&lang=js&"
export * from "./BuyProductXGiftY.vue?vue&type=script&lang=js&"
import style0 from "./BuyProductXGiftY.vue?vue&type=style&index=0&id=c74a40ba&scoped=true&lang=scss&"
import style1 from "./BuyProductXGiftY.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a40ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VIcon,VRow,VSelect,VSimpleTable,VTextField,VTooltip})
